import { CustomRequestInit, Methods } from './types';
import { useToken } from './useToken';

export async function useFetch<T>(
  url: string,
  body?: BodyInit | null,
  method?: Methods,
  options?: CustomRequestInit,
  external?: boolean,
  cache?: RequestCache
): Promise<T> {
  const token = await useToken();

  const defaultOptions: RequestInit = {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      ...options?.headers
    },
    method,
    body
  };

  const response = await fetch(external ? url : `${process.env.API}${url}`, {
    cache: cache ?? 'no-cache',
    ...defaultOptions,
    ...options
  });

  if (!response.ok) {
    const data = await response?.json();
    return data;
  }

  const data = await response?.json();
  return data;
}
